import dynamic from 'next/dynamic'
import BasicLoader from '~/components/traffic-tickets/screens/basicLoader'
import Router from "next/router"
import {getRoot} from "mobx-state-tree"
import {getStepFromSlug} from "~/components/traffic-tickets/steps/steps"

const VIOLATION_SELECTOR_CONFIGURATION = {
  slug: 'violation',
  Component: dynamic(() => import('./index'), {
    loading: BasicLoader
    // ssr: false
  }),
  validateKeys: ['violationName'],
  validatationTarget: self => self.trafficTickets,
  // eslint-disable-next-line
  onEnter: async self => {
    const rootStore = getRoot(self)
    if (!rootStore.trafficSubmission.selectedState.available && !rootStore.trafficSubmission.selectedState.isPQFlowEnabled) {
      self.setIsLoading(true); // prevent flicker while redirecting
      self.setStep(getStepFromSlug('user-info',rootStore.trafficSubmission.selectedState.available))
    }
    if (
      !self.movingViolations.length &&
      !self.movingViolationService.isLoading
    ) {
      await self.loadViolations()
    }
    self.setIsLoading(false)
  },
  // eslint-disable-next-line
  onExit: async self => {
    // let saved = false
    //
    // // try updating the ticket
    //
    // try {
    //   const TRAFFIC_TICKET_KEYS_TO_SAVE = ['violationName', 'points']
    //   const ticketSavePromises = self.trafficTickets.map(ticket => {
    //     return ticket.updateTicket(TRAFFIC_TICKET_KEYS_TO_SAVE)
    //   })
    //
    //   await Promise.all(ticketSavePromises)
    //   saved = true
    // } catch (err) {
    //   saved = false
    //   self.changeStatusText(null)
    //   self.showErrorToast(`We could not save your ticket. Please try again.`)
    //   if (process.env.WINIT_ENV !== 'test') {
    //     console.error('Error creating/updating ticket with violations', err)
    //   }
    // }
    //
    // return saved // to allow continue
    return true
  }
}

export default VIOLATION_SELECTOR_CONFIGURATION
